import cn from 'classnames'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import dates from 'react-big-calendar/lib/utils/dates'
import { Popover } from 'antd'

class LeaveSlotGroup extends Component {
    static propTypes = {
        renderSlot: PropTypes.func,
        resource: PropTypes.any,
        components: PropTypes.object,
        getters: PropTypes.object,
    }

    timeSlotEventDetails = (slot, events) => {
        let empSlot = []
        let timeRange = {}
        let employees = this.props.employees
        let branch = this.props.branches
        let departments = this.props.departments
        let slotRangeEnd = dates.add(slot, 1, 'hours')

        let slotEvents = (events || []).filter(event =>
            // dates.inRange(event.start, slot, slotRangeEnd, 'hours')
            this.overlapTest(event.start, event.end, slot)
        )

        let tmp = (slotEvents || []).forEach(event => {
            let empList = (employees || []).filter(
                emp => event.EmployeeID === emp.EmployeeID
            )
            empSlot.push(_.head(empList))
        })

        return empSlot
    }

    overlapTest = (start, end, timeSlot) => {
        const timeSlotEnd = dates.add(timeSlot, 1, 'hours')

        if (dates.lt(start, timeSlot)) {
            if (dates.lte(end, timeSlot)) {
                return false
            } else {
                return true
            }
        } else if (dates.gte(start, timeSlotEnd)) {
            return false
        } else {
            return true
        }
    }

    renderPopover = event => {
        const filterdAction = _.find(this.props.actionTypes, act => act.value === _.head(event).ActionType)

        return <div>{filterdAction.label}</div>
    }

    render() {
        const { renderSlot, resource, key, emp, daysEvents } = this.props

        return (
            <div>
                {daysEvents.length > 0 ? (
                    <Popover
                        placement="rightTop"
                        content={this.renderPopover(daysEvents)}
                        trigger="hover"
                    >
                        <div className="rbc-timeslot-group">
                            <div
                                className={cn(
                                    'rbc-time-slot',
                                    'reportcelldefault'
                                )}
                            >
                                {renderSlot &&
                                    renderSlot(
                                        key,
                                        emp,
                                        daysEvents,
                                        'spanstyle'
                                    )}
                            </div>
                        </div>
                    </Popover>
                ) : (
                    <div className="rbc-timeslot-group">
                        <div
                            className={cn('rbc-time-slot', 'reportcelldefault')}
                        >
                            {renderSlot &&
                                renderSlot(key, emp, daysEvents, 'spanstyle')}
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        employees: state.roster.employeeList,
        branches: state.BranchReducer.branchList,
        departments: state.DepartmentReducer.departmentList,
        actionTypes: state.ActionTypesReducer.actionTypes,
    }
}

export default connect(mapStateToProps)(LeaveSlotGroup)
